<template>
  <div class="">
    <div class="">
      <!-- top blank 번역 매뉴가 화면을 가려서 넣어둠-->
      <div class="mt-10"></div>

      <div
        v-if="is_dev"
        class="m-2 p-2 border-2 border-black dark:border-white"
      >
        DEV MODE
      </div>

      <div
        v-if="page.need_update"
        class="m-2 p-2 border-2 border-black dark:border-white"
      >
        NEED UPDATE PAGE
        <button class="ml-4" @click="onPageReload">RELOAD</button>
      </div>

      <div v-if="need_refresh" class="flex m-2 p-2 border-2 items-center">
        <div>NEED REFRESH PAGE</div>
        <div class="ml-8 tw_button">
          <button @click="onRefresh">REFRESH</button>
        </div>
      </div>

      <!-- TOPBAR 좌우 -->
      <div class="m-2 flex justify-between">
        <div>
          <h1>SIDNFT</h1>
        </div>
        <div>
          <!-- 다크모드 전환 -->
          <div class="m-2 rounded-2xl">
            <motion.button
              :while-hover="{ scale: 2.0 }"
              :while-press="{ scale: 0.8 }"
              @click="onToggleDark()"
              class="flex justify-center items-center"
            >
              <Icon
                v-if="is_dark"
                icon="material-symbols:sunny"
                class="w-8 h-8"
              />
              <Icon v-else icon="material-symbols:dark-mode" class="w-8 h-8" />
            </motion.button>
          </div>
        </div>
      </div>

      <!-- apps 로고 -->
      <div class="m-2 p-2 flex justify-center items-center">
        <motion.button
          :while-hover="{ scale: 1.5 }"
          :while-press="{ scale: 0.8 }"
          @click="onPush('/')"
          class="flex items-center"
        >
          <Icon class="w-16 h-16" icon="basil:app-store-outline" />
          <div class="text-4xl">pps</div>
        </motion.button>
      </div>

      <!-- 상단 메뉴 시작 -->
      <nav v-if="true">
        <!-- 모바일 화면 -->
        <div class="block md:hidden">
          <div v-if="page.is_show_menus == false" class="m-4">
            <button @click="page.is_show_menus = true">☰ SHOW MENUS</button>
          </div>
          <div v-else class="m-4">
            <div>
              <button @click="page.is_show_menus = false">✖ HIDE MENUS</button>
            </div>
            <div class="flex">
              <div
                v-for="data of top_menu_list"
                :key="data.to"
                :class="menu_class(data)"
              >
                <router-link :to="data.to">{{ data.label }}</router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- 일반 화면 -->
        <div class="hidden md:block">
          <div class="flex justify-center m-4">
            <div
              v-for="data of top_menu_list"
              :key="data.to"
              :class="menu_class(data)"
            >
              <router-link :to="data.to">{{ data.label }}</router-link>
            </div>
          </div>
        </div>
      </nav>

      <div class="mt-8">
        <main class="tw_main">
          <router-view />
        </main>
      </div>

      <!-- footer -->
      <div class="mt-8 grid grid-cols-2 md:grid-cols-3">
        <div class="m-2">
          <div class="text-xl font-bold">SIDNFT</div>
          <div class="ml-4">
            <a href="/sidnft_policy"> PRIVACY POLICY </a>
          </div>
          <div class="ml-4">
            <a href="/sidnft_service"> SERVICE POLICY</a>
          </div>
          <!-- <div class="ml-4">
            <a href="/nft-dev"> NFT-DEV</a>
          </div> -->
        </div>

        <div class="m-2">
          <div class="text-xl font-bold flex justify-start items-center">
            <div>SNS</div>
            <!-- <Icon class="ml-4 w-8 h-8" icon="material-symbols:link" /> -->
          </div>
          <div class="flex flex-wrap">
            <div class="ml-2">
              <a href="https://x.com/GMetaverse" target="_blank">
                <Icon class="tw_icon" icon="ri:twitter-x-fill" />
              </a>
            </div>
            <div class="ml-2">
              <a
                href="https://www.threads.com/@gotothemetaverse"
                target="_blank"
              >
                <Icon class="tw_icon" icon="ri:threads-fill" />
              </a>
            </div>
            <!-- discord -->
            <div class="ml-2">
              <a
                href="https://discord.com/channels/929203794871468092/1356192245975613553"
                target="_blank"
              >
                <im2 class="tw_icon" src="/images/discord_icon.png" />
              </a>
            </div>
            <div class="ml-2">
              <a
                href="https://www.youtube.com/@%EC%9D%B4%EB%A0%87%EA%B2%8C%EB%90%9C%EC%9D%B4%EC%83%81%EB%A9%94%ED%83%80%EB%B2%84%EC%8A%A4/"
                target="_blank"
              >
                <Icon class="tw_icon" icon="ri:youtube-fill" />
              </a>
            </div>
            <div class="ml-2">
              <a href="https://addforce1.blogspot.com/" target="_blank">
                <Icon class="tw_icon" icon="ri:blogger-fill" />
              </a>
            </div>
          </div>
        </div>

        <!-- 다른 프로젝트들 -->
        <div class="m-2">
          <div class="text-xl font-bold">PROJECTS</div>
          <div class="ml-4">
            <a href="https://bitaxe.sidnft.com/" target="_blank">BITAXE</a>
          </div>
          <div class="ml-4">
            <a href="https://room.sidnft.com/" target="_blank">ROOM</a>
          </div>
          <div class="ml-4">
            <a href="https://www.aivtuber.kro.kr/" target="_blank">AIV</a>
          </div>
          <!-- <div class="ml-4">
            <a href="https://unity.sidnft.com/" target="_blank">TECH DEMO</a>
          </div> -->
        </div>

        <!-- grid end -->
      </div>

      <!-- version -->
      <div class="m-2 flex justify-end items-center">
        <div class="font-bold">v{{ VERSION }}</div>
        <div class="ml-2" v-if="is_dev">DEV</div>
        <div class="ml-2 text-xs">({{ moment(BUILD_DATE).fromNow() }})</div>
        <div v-if="is_dev" class="ml-2 text-xs">c:{{ time_count }}</div>

        <div class="ml-2 h-6 items-end">
          <div v-if="IS_DEV">DEV_NO_COUNTER</div>
          <iframe
            v-else
            src="https://myhits.vercel.app/api/hit/https%3A%2F%2Fapps.sidnft.com?color=blue&label=hits&size=small&base_count=1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// App.vue
import * as Vue from "vue";
import { motion } from "motion-v";
import { useRoute, useRouter } from "vue-router";
import { useDark, useStorage, useToggle } from "@vueuse/core";
import { Icon } from "@iconify/vue";
import { VERSION, BUILD_DATE } from "@/ver";
import moment from "moment";
import im2 from "@/components/Img2.vue";
import * as Helper from "./helper";

Icon;

const URL_HEAD = Helper.get_url_head();

// 사용할 지갑 목록 (Petra 등 설치 필요)
const IS_DEV = Helper.is_dev();
const route = useRoute();
const router = useRouter();
// const store = Helper.useStore();
const store = Helper.usePinia();
const is_dark = useDark();
const toggle_dark = useToggle(is_dark);
const need_refresh = Vue.ref(false);

const is_dev = Vue.ref(true);
if (Helper.is_dev()) {
  // console.log("is_dev");
} else {
  is_dev.value = false;
  console.log = () => {};
  console.info = () => {};
  console.error = () => {};
}

const page = Vue.ref({
  //
  need_update: false,
  is_show_menus: false,
});

const top_menu_list = Vue.ref([
  {
    label: "HOME",
    to: "/",
  },
  {
    label: "DEV LOG",
    to: "/works",
  },
  {
    label: "DEV-NEWS (KR)",
    to: "/news",
  },
]);

//
const menu_class = (data) => {
  // console.log("menu_class start", data);

  var base = "tw_menu_item";
  if (is_dark.value) {
    base = "tw_menu_item_dark";
  }

  var enable = "";
  if (data.to == route.fullPath) {
    enable = "tw_menu_disabled";
    if (is_dark.value) {
      enable = "tw_menu_disabled_dark";
    }
  }

  var ret = base + " " + enable;
  // console.log("class", data.to, ret);
  return ret;
};


// const is_enable = (input) => {
//   //console.log("is_enable", route.fullPath, input);
//   if (input == route.fullPath) {
//     return "tw-border";
//   }
//   return "";
// };

const onPush = (to: string) => {
  setTimeout(() => {
    router.push(to);
  }, 500);
};

const onToggleDark = () => {
  setTimeout(() => {
    if (toggle_dark) {
      toggle_dark.apply(undefined);
    }
  }, 100);
};

const time_count = Vue.computed(() => {
  // var v = pinia.doubleCount;
  // console.log("count", v);
  // return v;
  return store.count;
});

Vue.onMounted(async () => {
  console.log("App onMounted start");

  if (VERSION + 1 == 0) {
    console.log("skip warning", VERSION, BUILD_DATE);
  }

  // 엡 초기화
  // store.commit("app_init");
  store.app_init();

  // onFirst
  var url = URL_HEAD + "/api/ver_release/apps";
  var res_data = await Helper.web_get(url);
  var data = res_data.data;
  // console.log("ver_release res", data);

  // db 시간차이 저장
  Helper.set_dbdate_offset(data.dbdate_offset);

  // console.log("data", data);
  if (data.code != 200) {
    throw new Error("ver_release fail");
  }
  if (typeof data.release_ver != "number") {
    throw new Error("ver_release fail");
  }

  // console.log("check_version", VERSION, data.release_ver);
  // console.log("check_version", data);
  if (VERSION < data.release_ver) {
    page.value.need_update = true;
  }

  console.log("App onMounted end");
});

const onRefresh = () => {
  console.log("onRefresh");
  window.location.reload();
};

const onPageReload = () => {
  location.reload();
};
</script>

<style>
/* @import url("https://fonts.googleapis.com/css2?family=Nanum+Gothic&family=Noto+Sans+KR:wght@100..900&display=swap");

#app {
  font-family: Helvetica, "Noto Sans KR", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 600;
  text-align: center;
  color: #2c3e50;
} 

 #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} 

 nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.tw-border {
  @apply border-2;
} */

#app {
  @apply bg-white dark:bg-black;
}
</style>
